// import { Slider } from "antd";
import * as React from "react";
import styled from "styled-components";
import { uniqueId } from "lodash/fp";
import { BasicLegend2 } from "../basic-legend-2";
// tslint:disable: variable-name
const Root = styled(BasicLegend2) `
  .list {
    flex: 1 1 100%;
    > table {
      height: 100%;
      margin: auto;
    }
    .item {
      cursor: pointer;
      &:hover {
        background-color: ${p => p.colorPalette.blackColor[1]};
      }
      &.not-active {
        .color {
          background-color: gray;
        }
      }
      td {
        padding: 0;
        /* 解决不可消失的padding问题 */
        font-size: 0;
      }
      height: 24px;
      justify-content: center;
      .color {
        width: 4px;
        height: 8px;
        margin: 2px 8px 2px 12px;
        display: inline-block;
        border-radius: 2px;
      }
      .name {
        font-size: 12px;
        line-height: 24px;
        display: inline-block;
        margin-right: 12px;
      }
    }
  }
`;
const Color = styled.div `
  background-color: ${props => props.color};
`;
/**
 * 渐变图层阶梯图例大屏版
 * 会自动合并相邻同色阶梯
 *
 * @author 张卓诚
 * @export
 * @class GradientIntervalLegend2
 * @extends {(React.PureComponent<GradientIntervalLegend2Props & ICSSProps & ColorProps<GlobalColorPalette>>)}
 * @implements {ICSS}
 * @implements {Color<GlobalColorPalette>}
 * @implements {(Legend<GradientIntervalLegend2Props & BasicLegendProps>)}
 */
export class GradientIntervalLegend2 extends React.PureComponent {
    constructor() {
        super(...arguments);
        /**
         * 和include有交集就行
         *
         * @private
         * @memberof GradientIntervalLegend
         */
        this.isShow = (item, nextItem) => {
            const include = this.props.include;
            for (let i = 0; i < this.props.include.length; i++) {
                // 左闭右开
                // tslint:disable-next-line:no-collapsible-if
                if (nextItem === undefined) {
                    if (item[0] < include[i][1]) {
                        return true;
                    }
                    continue;
                }
                /**
                 * 思路就是如果两个区间相交，那么最大的开始端一定大于最小的结束端
                 * Math.max(include[i][0], item[0]) < Math.min(include[i][1], nextItem[0])
                 */
                if (include[i][0] <= item[0] && include[i][1] >= nextItem[0]) {
                    return true;
                }
            }
            return false;
        };
        /**
         * 传入一个要切换显隐状态的指
         * 返回切换了显隐状态后的include值
         *
         * @private
         * @memberof GradientIntervalLegend
         */
        this.caculateToggledInclude = (num) => {
            // 用colors生成include
            const showStates = this.mergeInterval(this.props.colors).map((item, index, mcs) => [
                item[0],
                item[1],
                this.isShow(item, mcs[index + 1]),
            ]);
            showStates.forEach(item => {
                if (item[0] === num) {
                    item[2] = !item[2];
                }
            });
            const include = [];
            showStates.forEach((item, index) => {
                if (index === showStates.length - 1) {
                    if (item[2]) {
                        include.push([
                            item[0],
                            this.props.colors[this.props.colors.length - 1][0],
                        ]);
                    }
                    // tslint:disable-next-line: no-collapsible-if
                }
                else {
                    if (item[2]) {
                        include.push([item[0], showStates[index + 1][0]]);
                    }
                }
            });
            const mergedResult = [];
            // 合并相邻区域，在某些情况下能让gradient-legend显示的更好
            // 处理include为空的情况
            if (include.length === 0) {
                // tslint:disable-next-line: no-unnecessary-type-assertion
                return [[num, num]];
            }
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < include.length; i++) {
                if (mergedResult.length === 0) {
                    mergedResult.push(include[i]);
                }
                else if (include[i][0] <= mergedResult[mergedResult.length - 1][1]) {
                    mergedResult[mergedResult.length - 1][1] = include[i][1];
                }
                else {
                    mergedResult.push(include[i]);
                }
            }
            return mergedResult;
        };
        /** include变化事件 */
        this.onChange = (num) => {
            if (this.props.changeInclude) {
                this.props.changeInclude(this.caculateToggledInclude(num));
            }
        };
        /**
         * 合并相邻的相同颜色的阶梯
         * 主要合并开头两个阶梯和最后两个阶梯
         * 包含下限，不包含上限
         *
         * @private
         * @memberof GradientIntervalLegend
         */
        this.mergeInterval = (colors) => {
            const result = [];
            // tslint:disable-next-line: prefer-for-of
            for (let i = 0; i < colors.length; i++) {
                if (result.length === 0) {
                    result.push(colors[i]);
                }
                else if (colors[i][1] !== result[result.length - 1][1]) {
                    result.push(colors[i]);
                }
            }
            return result;
        };
    }
    render() {
        const mergedColors = this.mergeInterval(this.props.colors);
        const marks = {};
        // let start: React.ReactNode;
        // let end: React.ReactNode;
        mergedColors.forEach((item, index) => {
            if (index === 0) {
                // start = this.props.names[index];
            }
            else if (index === mergedColors.length - 1) {
                // end = this.props.names[index];
                // tslint:disable-next-line: no-collapsible-if
            }
            else {
                if (this.props.names[index]) {
                    marks[item[0]] = this.props.names[index];
                }
            }
        });
        // const gradientLinerColor = graidentColor(colors,min,max,"top");
        return (React.createElement(Root, { theme: this.props.theme, style: this.props.style, className: this.props.className, colorPalette: this.props.colorPalette, title: this.props.title, unit: this.props.unit },
            React.createElement("table", null,
                React.createElement("tbody", null, 
                // tslint:disable: jsx-no-multiline-js
                mergedColors
                    .slice()
                    .reverse()
                    .map((item, index, mcs) => (React.createElement("tr", { key: uniqueId("gradient-interval-legend"), className: "item" +
                        (!this.isShow(item, mcs[index - 1])
                            ? " not-active"
                            : ""), onClick: () => this.onChange(item[0]) },
                    React.createElement("td", null,
                        React.createElement(Color, { className: "color", color: item[1] })),
                    React.createElement("td", null,
                        React.createElement("div", { className: "name" }, this.props.names.slice().reverse()[index])))))))));
    }
}
GradientIntervalLegend2.defaultProps = {
    theme: "dark",
};
//# sourceMappingURL=index.js.map